<template>

	<div class="board_list">
		<ul class="curriculum_list">
			<!-- 교육과정 게시판은 게시글 4개 -->
			<li :id="'item-' + item.emIdx" v-for="(item, index) in courseList">
				<a href="javascript:;" @click="goDetail(item)">
					<figure class="list_thumb" v-if="!$options.filters.isEmpty(item.thumbnail)">
						<img v-if="item.thumbnail != null && item.thumbnail !== ''" :src="item.thumbnail" alt="" style="object-fit: cover; aspect-ratio: 1 / 1;">
						<img v-else src="/ssflex/assets/img/common/img_thumb.svg">
						<span class="class_num">{{ item.eduMainList != null ? item.eduMainList.length : 0 }}</span><!-- 모바일용 클래스 갯수 표시-->
					</figure>
					<div class="list_text">
						<em class="cate">
							<span class="notice_cate m-r-5">{{ item.shortTitle }}</span>
							<span v-if="item.cateCode != null">{{ item.cateCodeVO.codeName }}</span>
						</em>
						<strong class="tit">{{ item.title }}</strong>
						<div class="desc">{{ item.comment }}</div>
						<ul class="class_list">

							<template v-for="(sitem, sidx) in item.eduMainList">
								<li v-if="sidx < 4" >
									<img v-if="sitem.thumbnail != null && sitem.thumbnail !== ''" :src="sitem.thumbnail" style="object-fit: cover; aspect-ratio: 1 / 1;">
									<img v-else src="/ssflex/assets/img/common/img_thumb.svg">
								</li>
								<li v-if="sidx === 5" class="over">
									<span>+{{ item.eduMainList.length - 5 }}</span>
									<img v-if="sitem.thumbnail != null && sitem.thumbnail !== ''" :src="sitem.thumbnail" style="object-fit: cover; aspect-ratio: 1 / 1;">
									<img v-else src="/ssflex/assets/img/common/img_thumb.svg">
								</li>
							</template>
						</ul>
					</div>
				</a>
			</li>
		</ul>
	</div>

</template>

<script>

export default {
	name: "courseList",
	props: {
		forApp: {
			type: Boolean,
			default: false,
		},
		courseList: Array,
	},
	data() {



		return {
			//eduList: [],
			eduCount: 0,
		}
	},
	created() {

	},
	mounted() {
	},
	methods: {


		goDetail( _item ) {
			if (this.$route.name === "appSearchers") {
				this.webUtils.goTo(this, `/app/education/course/${_item.cateCode.slice(0, 6)}?mode=detail&cidx=${_item.cidx}`, true)
			}
			console.log( this.forApp )
			if ( this.forApp ) {
				this.goAppEducation(_item.cateCode, _item.cidx)
				this.webUtils.scrollTo("#app")
			}
			this.$eventBus.$emit("goDetail", _item.cidx)
		},

	},
}
</script>

<style scoped>

</style>
